import {
  addUser,
  removeUser,
  authorised,
  addLoaderLoading,
  removeLoaderLoading,
} from "../constants/userConstant";

const userData = {
  userData: null,
  userAuthorization: false,
  loaderLoading: false,
};

const UserReducer = (state = userData, action) => {
  switch (action.type) {
    case addUser:
      const { userDetails } = action.payload;
      return { ...state, userData: userDetails };
    case authorised:
      return { ...state, userAuthorization: true };
    case removeUser:
      return { ...state, userAuthorization: false, userData: null };
    case addLoaderLoading:
      return { ...state, loaderLoading: true };
    case removeLoaderLoading:
      return { ...state, loaderLoading: false };
    default:
      return state;
  }
};

export default UserReducer;
